import { Breadcrumb } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

// Define a mapping between pathnames and display names for the breadcrumb
const pathToName: Record<string, string> = {
  '/about-us': 'About Us',
  '/board-members': 'Executive Committee',
  '/community': 'Community',
  '/maintenance': 'Maintenance',
  '/projects': 'Projects',
  '/projects/water-management': 'Water Management',
  '/projects/solar': 'Solar Power Initiative',
  '/projects/ecostp': 'ECO STP',
  '/projects/community-center': 'Community Center',
  '/gallery': 'Gallery',
  '/nearby-locality': 'Near By Locality',
  '/faq': 'FAQ',
  '/support': 'Support',
  '/greenary': 'Greenary',
};

// Define parent paths for community section
const communityPaths = [
  '/maintenance',
  '/projects',
  '/gallery',
  '/nearby-locality',
];

// Define project detail paths
const projectDetailPaths = [
  '/projects/water-management',
  '/projects/solar',
  '/projects/ecostp',
  '/projects/community-center',
];

const CustomBreadcrumb = () => {
  const location = useLocation();

  // If we're on the home page, do not render breadcrumbs
  if (location.pathname === '/') {
    return null;
  }

  const isInCommunity =
    location.pathname === '/community' ||
    communityPaths.some((path) => location.pathname === path);

  const isProjectDetail = projectDetailPaths.some(
    (path) => location.pathname === path
  );

  return (
    <Breadcrumb className="my-3 custom-breadcrumb">
      {/* Home breadcrumb */}
      <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
        Home
      </Breadcrumb.Item>

      {/* Project detail pages */}
      {isProjectDetail ? (
        <>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/community' }}>
            Community
          </Breadcrumb.Item>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/projects' }}>
            Projects
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {pathToName[location.pathname]}
          </Breadcrumb.Item>
        </>
      ) : (
        /* Regular community pages */
        isInCommunity &&
        (location.pathname === '/community' ? (
          <Breadcrumb.Item active>Community</Breadcrumb.Item>
        ) : (
          <>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/community' }}>
              Community
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {pathToName[location.pathname]}
            </Breadcrumb.Item>
          </>
        ))
      )}

      {/* Non-community pages */}
      {!isInCommunity && !isProjectDetail && (
        <Breadcrumb.Item active>
          {pathToName[location.pathname]}
        </Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};

export default CustomBreadcrumb;
